import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ArrowRightSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M22 12.094C22 11.8598 21.8967 11.6478 21.7089 11.4696L14.5479 4.29677C14.3303 4.0844 14.1193 4 13.8946 4C13.4304 4 13.0738 4.34708 13.0738 4.81225C13.0738 5.03698 13.1445 5.25746 13.3038 5.40731L16.1253 8.27203L20.0982 11.9276L20.2944 11.4378L16.9704 11.2491H2.83547C2.34707 11.2491 2 11.6056 2 12.094C2 12.5824 2.34707 12.939 2.83547 12.939H16.9704L20.2944 12.7503L20.0982 12.27L16.1253 15.916L13.3038 18.7808C13.1487 18.9263 13.0738 19.1511 13.0738 19.3758C13.0738 19.841 13.4304 20.1881 13.8946 20.1881C14.1193 20.1881 14.3218 20.1037 14.5096 19.9296L21.7089 12.7185C21.8967 12.5402 22 12.3283 22 12.094Z"
        fill={color}
      />
    </svg>
  );
};

export { ArrowRightSvg };
